import type { ChangeEvent, FormEvent } from 'react'
import SearchField from '@molecules/SearchField'
import { scopedTranslation } from '@utils/I18n'
import useEventsFilteringStore from './stores/useEventsFilteringStore'

const t = scopedTranslation('shifts_overview.search_field')

export function EventSearchField() {
  const searchTerm = useEventsFilteringStore((state) => state.searchTerm)
  const setSearchTerm = useEventsFilteringStore((state) => state.setSearchTerm)

  return (
    <form
      className="tw:w-full"
      onSubmit={(event: FormEvent<HTMLFormElement>) => {
        event.preventDefault()
      }}
    >
      <SearchField
        fieldName="event_name"
        defaultValue={searchTerm}
        displayName={t('label')}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          setSearchTerm(event.target.value)
        }}
        dataCompId="shifts-overview_search-field"
      />
    </form>
  )
}
